import React from "react";

import tracking from "../../../utils/tracking";
import "./book-cta.scss";

const onClick = (evt, path, url) => {
  evt.preventDefault();

  tracking.event("customEvent", {
    eventCategory: "Book",
    eventAction: "click",
    eventLabel: path
  });

  window.location.href = url;
};

const BookCta = ({ link, label, path }) => {
  return (
    <a
      className="book-cta d-sm-none"
      onClick={evt => onClick(evt, path, link)}
      href={link}
    >
      <span>{label}</span>
    </a>
		// <span></span>
  );
};

export default BookCta;



// WEBPACK FOOTER //
// ./src/components/_common/BookCta/index.js